var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { NOT_INSURED_ISSUER_SLUG } from "../lib/constants";
import classNames from "classnames";
import { createSelector } from "@reduxjs/toolkit";
import useAppSelector from "../hooks/useAppSelector";
import useIsSupportedIssuer from "../hooks/useIsSupportedIssuer";
function getMessage(hasSelectedIssuer, hasSupportedIssuer) {
    if (!hasSelectedIssuer) {
        return "You are not eligible for points or rewards without an active insurance policy.";
    }
    if (hasSelectedIssuer && hasSupportedIssuer) {
        return "You must log in to your insurance account to claim points or rewards.";
    }
    return "Your insurer is not supported for points or rewards.";
}
export default function IncentivizedBanner(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var utmMedium = useAppSelector(function (state) { return state.configuration; }).utmMedium;
    var isSupportedIssuer = useIsSupportedIssuer();
    var message = useAppSelector(createSelector(function (state) { return state.applicant.currentIssuer.auto; }, function (selectedIssuer) {
        var hasSelectedIssuer = Boolean(selectedIssuer && selectedIssuer.id !== NOT_INSURED_ISSUER_SLUG);
        var hasSupportedIssuer = Boolean(selectedIssuer && isSupportedIssuer(selectedIssuer));
        return getMessage(hasSelectedIssuer, hasSupportedIssuer);
    }));
    var isIncentivized = /incentive/i.test(utmMedium || "");
    if (!isIncentivized) {
        return null;
    }
    return (React.createElement("div", __assign({ id: "incentivized-banner", className: classNames("rounded-lg border border-dashed border-gray-100 bg-[#FFF9DA] p-4 text-sm leading-4 tracking-tight text-black-300", className) }, rest), message));
}
